import { render, staticRenderFns } from "./JoinTerms.vue?vue&type=template&id=1edceb34&scoped=true"
import script from "./JoinTerms.vue?vue&type=script&lang=js"
export * from "./JoinTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edceb34",
  null
  
)

export default component.exports